import styled from 'styled-components'

export const PopUpContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
export const PopUpHeader = styled.div`
  background-color: #0066B3;
  height: 53px;
  border-radius: 4px 4px 0 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 24px;
`
export const PopUpTitle = styled.h4`
  color: #fff;
  font-size: 20px;
  margin-top: 1rem;
  margin-bottom: 1rem;
`
export const PopUpContent = styled.div`
  height: auto;
  min-height: 100px;
  max-height: 500px;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  white-space: pre-line;
  padding: 12px;
`
export const PopUpParagraph = styled.span`
  font-size: 16px;
  line-height: 18.75px;
  color: #464646;
  overflow: auto;
  width: 100%;
`
